var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.0864 460.816L30 0H481.474L440.344 460.741L255.464 512L71.0864 460.816Z",
    fill: "#0071BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.116 472.795L405.323 431.748L440.282 38.3764H256.116V472.795Z",
    fill: "#29ABE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.047 207.678L128.996 264.112L256.116 207.678V151.152L124.047 207.678Z",
    fill: "#B3B3B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.906 90.8141L256.116 151.152V207.678L392.052 147.248L396.906 90.8141Z",
    fill: "#E6E6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.116 355.337L255.679 355.403L192.637 338.472L188.518 293.458H131.78L139.698 382.139L255.667 414.249L256.116 414.143V355.337Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.116 207.678V264.112H325.138L318.864 337.896L256.116 355.386V414.187L371.701 382.077L386.921 207.678H256.116Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.116 207.678H124.047L128.996 264.112H256.116V207.678Z",
    fill: "#E6E6E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.116 147.248V90.8141H255.543H114.013L119.021 147.248H256.116Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.116 90.8141V146.541V147.248H392.052L396.906 90.8141H256.116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.b507c742e4c492f3fb20108fcab2a9d5.svg";
export { ForwardRef as ReactComponent };